import { request } from '@/utils/http'

/**
 * 上传附加费 Excel (异步任务，返回 taskId)
 * @param type 附加费导入类型，支持 lcl、air、fcl、pre-port、last-mile、rail
 * @param file Excel文件
 */
export type SurchargeImportType = 'lcl' | 'air' | 'fcl' | 'pre-port' | 'last-mile' | 'rail'

/** 上传附加费 Excel，后端创建异步导入任务并返回 taskId。 */
export const uploadSurchargeExcel = (type: SurchargeImportType, file: File) => {
  const formData = new FormData()
  formData.append('file', file)
  return request.post<string>(`/mq/surcharge/excel/upload?type=${type}`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}

/**
 * 确认导入附加费 (上架本批次草稿)
 * @param type 附加费导入类型
 */
export const confirmSurchargeImport = (type: SurchargeImportType, batchNo: string, taskId: string) =>
  request.post<boolean>('/mq/surcharge/excel/confirm', null, {
    params: { type, batchNo, taskId }
  })

/**
 * 取消导入附加费 (删除本批次草稿)
 * @param type 附加费导入类型
 */
export const cancelSurchargeImport = (type: SurchargeImportType, batchNo: string, taskId: string) =>
  request.post<boolean>('/mq/surcharge/excel/cancel', null, {
    params: { type, batchNo, taskId }
  })
